
import { Injectable } from '@angular/core';
import { Resolve, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { RtoLoadHistService } from './rto-load-hist.service';
import { LoadHist } from '../Models/LoadsData';

@Injectable({
  providedIn: 'root'
})
export class RtoLoadResolverService implements Resolve<Array<LoadHist>> {
  rtoYearHistData: Observable<Array<LoadHist>>;
  constructor(private RtoLoadSvc: RtoLoadHistService) { }
  resolve(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<Array<LoadHist>> | Promise<Array<LoadHist>> | Array<LoadHist> {

    this.rtoYearHistData = this.RtoLoadSvc.getRTOHistData("1-12True")
    return this.rtoYearHistData;
  }
}
